<div
  #positionModal
  [ngClass]="{
    'modal-dialog-desktop': deviceType.isDesktop,
    'modal-dialog-mobile': deviceType.isMobile || deviceType.isTablet,
  }"
  role="document"
>
  <div class="modal-header align-items-center justify-content-between">
    <h2 class="xs-title bold" id="modal-basic-title">{{ title }}</h2>
    <button (click)="dismiss()" class="d-flex align-items-center border-0 bg-transparent">
      <span class="md-icon md-icon-close"></span>
    </button>
  </div>
  <div class="modal-body">
    @if (showUserIcon) {
      <div>
        <p-avatar shape="circle" [image]="imagPath" class="med_user-circle"> </p-avatar>
      </div>
    }
    <div class="med_dialog-content vstack gap-4">
      @for (input of formStructure; track $index) {
        <div>
          <label class="form-label" [for]="'form-input-' + $index">{{ input.name }}</label>
          @if (input.type != "password") {
            <input
              [type]="input.type"
              class="form-control"
              [id]="'form-input-' + $index"
              [(ngModel)]="input.value"
              [disabled]="input.disabled"
            />
          }
          @if (input.type == "password") {
            <input
              (focus)="input.value = ''"
              type="password"
              class="form-control"
              [id]="'form-input-' + $index"
              [(ngModel)]="input.value"
              [disabled]="input.disabled"
            />
          }
        </div>
      }
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary w-100" (click)="close()">Save</button>
  </div>
</div>
